exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-links a[data-v-d17ec49c]{padding-left:10px}", ""]);

// exports
